import type { LottieHandle } from './types';

const handles = new Map<string, LottieHandle[]>();

export function registerLottie(frameId: string, hs: LottieHandle[]): void {
  handles.set(frameId, hs);
}

export function unregisterLottie(frameId: string): void {
  handles.delete(frameId);
}

export function getLottieHandles(frameId: string): LottieHandle[] {
  return handles.get(frameId) ?? [];
}
